<nb-layout>
  <nb-layout-header fixed>
    <div class="flex-container" style="width: 100%; display: flex;">
      <div class="text-left" style="flex-grow: 1">
        <button nbButton size="large" (click)="toggle()" status="primary"><nb-icon icon="menu-outline" ></nb-icon> filters </button>
      </div>

      <div class="text-left" style="flex-grow: 3">
        <a href="https://dasec.ma">
          <img src="../../assets/logoo.svg" width="150rem">
        </a>
      </div>

      <div style="flex-grow: 7"></div>

      <div class="text-right" style="flex-grow: 30">
        <button nbButton size="large" (click)="openInfo()" status="info"> Info<nb-icon icon="alert-circle-outline" ></nb-icon> </button>

      </div>
    </div>
  </nb-layout-header>

  <nb-sidebar tag="left"
              responsive="true"
              [collapsedBreakpoints]="['xs', 'is', 'sm', 'md', 'lg']">
    <nb-accordion>

      <nb-accordion-item expanded="true">
        <nb-accordion-item-header>Regions</nb-accordion-item-header>
        <nb-accordion-item-body>
          <button nbButton ghost status="info" (click)="unselectAll('region')">unselect all<nb-icon icon="square-outline"></nb-icon></button>
          <button nbButton ghost status="info" (click)="selectAll('region')">select all<nb-icon icon="checkmark-square-2-outline"></nb-icon></button>

          <nb-list *ngIf="render['cols']['region'].length > 0">
            <nb-list-item  *ngFor="let c of render['cols']['region']" >
              <nb-checkbox [value]="c"
                           [checked]="render['filters']['region'].includes(c)"
                           (checkedChange)="checked($event, c, 'region')">{{convertRegion(c)}}</nb-checkbox>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>

    </nb-accordion>

  </nb-sidebar>

  <nb-layout-column>


    <div class="row">

      <div class="col-lg-6 col-sm-12">
        <nb-card>
          <nb-card-header>Regions</nb-card-header>
          <nb-card-body [nbSpinner]="render['regions']==='await'">

            <ngx-chartjs-pie *ngIf="render['regions']!=='await'"
                             [data]=" {'datasets': [{'data': render['regions'].data[0] }], 'labels': render['regions'].labels}" ></ngx-chartjs-pie>

          </nb-card-body>
        </nb-card>
      </div>

      <div class="col-lg-6 col-sm-12">
        <nb-card>
          <nb-card-header>Human resources</nb-card-header>
          <nb-card-body [nbSpinner]="render['hr']==='await'">

            <ngx-chartjs-pie *ngIf="render['hr']!=='await'"
                             [data]=" {'datasets': render['hr'].data , 'labels': render['hr'].labels}" ></ngx-chartjs-pie>

          </nb-card-body>
        </nb-card>
      </div>
    </div>

    <div class="row">


      <div class="col-lg-6 col-sm-12">
        <nb-card>
          <nb-card-header>Cities</nb-card-header>
          <nb-card-body [nbSpinner]="render['cities']==='await'">

            <ngx-chartjs-bar *ngIf="render['cities']!=='await'"
                             [options]="{x:'city', y:'# of dialysis centers'}"
                             [data]=" {'datasets': render['cities'].data, 'labels': render['cities'].labels}" ></ngx-chartjs-bar>

          </nb-card-body>
        </nb-card>
      </div>

      <div class="col-lg-6 col-sm-12">
        <nb-card>
          <nb-card-header>Foundation date ( cumulative count )</nb-card-header>
          <nb-card-body [nbSpinner]="render['date']==='await'">

            <ngx-chartjs-line *ngIf="render['date']!=='await'"
                              [options]="{x:'year of foundation', y:'# of dialysis centers'}"
                              [data]=" {'datasets': render['date'].data, 'labels': render['date'].labels}" ></ngx-chartjs-line>

          </nb-card-body>
        </nb-card>
      </div>


    </div>


  </nb-layout-column>



</nb-layout>
